import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  teacherSubjectWithGroupsArray: [],
  lastDataLoadedTime: 0,
  
  // Training Courses state
  trainingCourses: [],
  trainingCoursesLoading: false,
  trainingCoursesError: null,
  addTrainingCourseLoading: false,
  addTrainingCourseError: null,
  updateTrainingCourseLoading: false,
  updateTrainingCourseError: null,
  deleteTrainingCourseLoading: false,
  deleteTrainingCourseError: null,
};

export const teachersManagementSlice = createSlice({
  initialState,
  name: 'teachersManagement',
  reducers: {
    getTeacherSubjectsWithGroupsRequestStart: state => {
      state.teacherSubjectWithGroupsArray = [];
      state.lastDataLoadedTime = 0;
    },
    getTeacherSubjectsWithGroupsRequestSuccess: (state, action) => {
      state.teacherSubjectWithGroupsArray = action.payload;
      state.lastDataLoadedTime = new Date().getTime();
    },
    getTeacherSubjectsWithGroupsRequestError: state => {
      state.teacherSubjectWithGroupsArray = [];
      state.lastDataLoadedTime = new Date().getTime();
    },

    
    getTrainingCoursesDataRequestStart: (state) => {
      state.trainingCoursesLoading = true;
      state.trainingCoursesError = null;
    },
    getTrainingCoursesDataRequestSuccess: (state, action) => {
      state.trainingCoursesLoading = false;
      state.trainingCourses = action.payload.data;
      state.trainingCoursesError = null;
    },
    getTrainingCoursesDataRequestError: (state, action) => {
      state.trainingCoursesLoading = false;
      state.trainingCoursesError = action.payload;
    },

    
    addTrainingCourseDataRequestStart: (state) => {
      state.addTrainingCourseLoading = true;
      state.addTrainingCourseError = null;
    },
    addTrainingCourseDataRequestSuccess: (state, action) => {
      state.addTrainingCourseLoading = false;
      state.addTrainingCourseError = null;
      
      if (state.trainingCourses) {
        state.trainingCourses.push(action.payload.data);
      }
    },
    addTrainingCourseDataRequestError: (state, action) => {
      state.addTrainingCourseLoading = false;
      state.addTrainingCourseError = action.payload;
    },

    
    updateTrainingCourseDataRequestStart: (state) => {
      state.updateTrainingCourseLoading = true;
      state.updateTrainingCourseError = null;
    },
    updateTrainingCourseDataRequestSuccess: (state, action) => {
      state.updateTrainingCourseLoading = false;
      state.updateTrainingCourseError = null;
      
      const updatedCourse = action.payload.data;
      const index = state.trainingCourses?.findIndex(course => course.ID === updatedCourse.ID);
      if (index !== -1 && state.trainingCourses) {
        state.trainingCourses[index] = updatedCourse;
      }
    },
    updateTrainingCourseDataRequestError: (state, action) => {
      state.updateTrainingCourseLoading = false;
      state.updateTrainingCourseError = action.payload;
    },

    
    deleteTrainingCourseDataRequestStart: (state) => {
      state.deleteTrainingCourseLoading = true;
      state.deleteTrainingCourseError = null;
    },
    deleteTrainingCourseDataRequestSuccess: (state, action) => {
      state.deleteTrainingCourseLoading = false;
      state.deleteTrainingCourseError = null;
      
      const { ID } = action.payload.meta;
      if (state.trainingCourses) {
        state.trainingCourses = state.trainingCourses.filter(course => course.ID !== ID);
      }
    },
    deleteTrainingCourseDataRequestError: (state, action) => {
      state.deleteTrainingCourseLoading = false;
      state.deleteTrainingCourseError = action.payload;
    },
  },
});

export default teachersManagementSlice.reducer;

export const {
  getTeacherSubjectsWithGroupsRequestStart,
  getTeacherSubjectsWithGroupsRequestSuccess,
  getTeacherSubjectsWithGroupsRequestError,
  
  
  getTrainingCoursesDataRequestStart,
  getTrainingCoursesDataRequestSuccess,
  getTrainingCoursesDataRequestError,
  addTrainingCourseDataRequestStart,
  addTrainingCourseDataRequestSuccess,
  addTrainingCourseDataRequestError,
  updateTrainingCourseDataRequestStart,
  updateTrainingCourseDataRequestSuccess,
  updateTrainingCourseDataRequestError,
  deleteTrainingCourseDataRequestStart,
  deleteTrainingCourseDataRequestSuccess,
  deleteTrainingCourseDataRequestError,
} = teachersManagementSlice.actions;